<template>
  <div class="w-full py-4 md:flex">
    <section class="w-full">
      <section
        class="hidden md:grid px-3"
        :class="LOADING ? 'bg-gray-lighter h-13' : 'bg-white h-13'"
      >
        <div v-show="LOADING">
          <div class="rounded-md p-4 max-w-sm w-full mx-auto"></div>
        </div>
        <img
          class="object-cover w-full rounded-lg h-56"
          :src="baseUrlSrc(banner_url)"
          alt=""
          @load="imgLoadHandler"
          v-show="!LOADING"
          @error="defaultImage"
        />
      </section>
      <div class="md:flex">
        <div class="md:w-8/12 px-3 md:py-8 py-2">
          <section>
            <div class="shadow p-3 rounded-lg ring-1 ring-gray-300">
              <h3 class="text-gray-dark font-bold text-md mb-5">Completed</h3>
              <div class="flex text-center justify-around items-center">
                <div class="flex flex-col justify-center items-center">
                  <img
                    class="w-14 rounded-full"
                    :src="require(`@/assets/img/sessions.svg`)"
                    alt="session"
                  />
                  <p class="px-6">
                    Classes<br />
                    <span>{{ sessions_count.default }}</span>
                  </p>
                </div>
                <div class="flex flex-col justify-center items-center">
                  <img
                    class="w-14 rounded-full"
                    :src="require(`@/assets/img/courses.svg`)"
                    alt="session"
                  />
                  <p class="px-6">
                    Class Packs<br />
                    <span>{{ course_count.default }}</span>
                  </p>
                </div>
                <div class="flex flex-col justify-center items-center">
                  <img
                    class="w-14 rounded-full"
                    :src="require(`@/assets/img/private.svg`)"
                    alt="session"
                  />
                  <p class="px-6">
                    Private<br />
                    <span
                      >{{ sessions_count.private + course_count.private }}
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </section>
          <div class="xl:flex shadow mt-4">
            <section class="p-3 pr-0 pl-0 ring-1 ring-gray-300 rounded-md">
              <div class="p-3 xl:w-40 w-full h-32 text-center">
                <h3 class="text-gray-dark font-bold text-md">Overall Rating</h3>
                <p class="font-bold-md text-3xl">
                  {{ reviews.average_rating }}
                </p>
                <div class="flex justify-center items-center">
                  <Rating :data="reviews.average_rating" />
                </div>
                <p>{{ reviews.total_count }} Reviews</p>
              </div>
            </section>
            <section class="p-3 pl-0 w-full ring-1 ring-gray-300 rounded-md">
              <div 
                class="p-3 w-full overflow-y-auto"
                :class="showDescritionModal === true ? 'h-32' : ''">
                <h3 class="text-gray-dark font-bold text-md">
                  About the trainer
                </h3>
                <p
                  class="text-gray-700 text-sm"
                  v-if="profile && profile.description"
                >
                  {{
                    showDescritionModal
                      ? profile && profile.description
                      : handleStr(profile && profile.description, 250)
                  }}
                </p>
                <p class="text-gray-700 text-sm" v-else>No description</p>
                <button
                  type="button"
                  class="text-green-light cursor-pointer focus:outline-none"
                  @click="showDescritionModal = !showDescritionModal"
                  v-if="
                    profile &&
                    profile.description &&
                    profile.description.length > 250
                  "
                >
                  Read {{ showDescritionModal ? "less" : "more" }}
                </button>
              </div>
            </section>
          </div>          
        </div>
        <section class="md:w-4/12 px-3 md:py-4 py-2">
          <div class="py-6 px-3 md:h-32">
            <h3 class="text-gray-dark font-bold text-md mb-2">Languages</h3>
            <div class="flex">
              <section v-if="profile.language_names">
                <div class="grid gap-4 grid-cols-2">
                  <span
                    class="text-gray-800 text-sm ml-1 capitalize flex items-center"
                    v-for="d in profile.language_names.split(',')"
                    :key="d.id"
                  >
                    <GlobeAlt />&nbsp;{{ d }}
                  </span>
                </div>
              </section>
            </div>
            
          </div>
          <div class="md:pt-8 pt-2 pb-4 px-2 md:mt-8">
            <h3 class="text-gray-dark font-bold text-md mb-2">Categories</h3>
            <div class="flex">
              <section v-if="profile.category_name">
                <div class="grid gap-2 grid-cols-2">
                  <span
                    class="h-8 px-4 text-pink-100 transition-colors duration-150 bg-pink-500 rounded-full focus:shadow-outline hover:bg-pink-600 py-1"
                    v-for="d in profile.category_name.split(',')"
                    :key="d.id"
                  >
                    {{ d }}
                  </span>
              </div>
              </section>
            </div>
          </div>
          <section class="px-2 pb-4 pt-2 md:pt-0 space-y-2">
            <div class="mb-5">
              <h3 class="text-gray-dark font-bold text-md mb-2">
                Private Class
              </h3>
              <p class="text-gray-light text-sm">
                Class cost around $
                {{ profile.private_cost ? profile.private_cost : 0 }}
                per hour
              </p>
            </div>
            <div>
              <router-link
                class="inline-flex items-center h-10 px-5 text-white transition-colors duration-150 bg-green-light rounded-lg focus:outline-none space-x-2"
                :to="{
                  name: 'UserMessage',
                  params: { trainer_id: profile.id },
                }"
                v-if="
                  (message_requests && message_requests.status == 1) ||
                  (message_requests && message_requests.status == 2)
                "
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="feather feather-message-square"
                >
                  <path
                    d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"
                  ></path>
                </svg>
                <span>
                  {{
                    message_requests.status == 1
                      ? "Request Pending"
                      : message_requests.status == 2
                      ? "You can chat now"
                      : ""
                  }}
                </span>
              </router-link>
              <button
                type="button"
                class="inline-flex items-center h-10 px-5 text-white transition-colors duration-150 bg-green-light rounded-lg focus:outline-none space-x-2 tooltip"
                v-else-if="message_requests && message_requests.status == 3"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="feather feather-message-square"
                >
                  <path
                    d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"
                  ></path>
                </svg>
                <span>Request Rejected</span>
                <span class="tooltiptext w-40 text-xs bg-gray-dark">
                  Please wait 1 day before sending another request.
                </span>
              </button>
              <button
                type="button"
                class="inline-flex items-center h-10 px-5 text-white transition-colors duration-150 bg-green-light rounded-lg focus:outline-none space-x-2"
                @click="messageTrainerModal"
                v-else
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="feather feather-message-square"
                >
                  <path
                    d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"
                  ></path>
                </svg>
                <span>Message the trainer</span>
              </button>
            </div>

            <Modal v-model="isModalOpen" :title="'Message Request'" :whiteCross="'text-white'">
              <form @submit.prevent="messageRequestHandler">
                <div class="mb-4 text-gray-700">
                  <label class="block mb-1 required font-medium text-xs"> Reason: </label>
                  <select
                    class="form-select block w-full mt-1 text-xs focus:outline-none bg-white ring-1 ring-gray-300 p-2 rounded-lg"
                    :class="{ 'border-red-700': $v.reason.$error }"
                    v-model="$v.reason.$model"
                  >
                    <option value="">Select</option>
                    <option value="1">Private Class Booking</option>
                    <option value="2">More Information About Class</option>
                    <option value="3">Others</option>
                  </select>
                  <div v-if="$v.reason.$error">
                    <span
                      class="text-xs text-red-700"
                      v-if="!$v.reason.required"
                      >Reason field is required</span
                    >
                  </div>
                </div>

                <div class="mb-4 text-gray-700">
                  <label class="block mb-1 required font-medium text-xs"> Message: </label>
                  <textarea
                    class="w-full h-24 px-3 py-2 text-base text-gray-700 placeholder-gray-500 ring-1 ring-gray-300 rounded-lg focus:outline-none"
                    rows="3"
                    placeholder="Enter your message here"
                    :class="{ 'ring-red-700': $v.message.$error }"
                    v-model="$v.message.$model"
                  ></textarea>
                  <div v-if="$v.message.$error">
                    <span
                      class="text-xs text-red-700"
                      v-if="!$v.message.required"
                      >Message field is required</span
                    >
                  </div>
                </div>

                <div class="mb-4 text-gray-700 float-right">
                  <button
                    type="button"
                    class="inline-flex items-center py-2 px-4 m-2 text-green-light transition-colors duration-150 ring-green-light rounded-lg focus:outline-none hover:bg-green-light hover:text-white ring-1 focus:ring focus:border-green-700"
                    @click="isModalOpen = !isModalOpen"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    class="py-2 w-24 px-4 m-2 text-green-100 transition-colors duration-150 bg-green-light rounded-lg focus:outline-none hover:bg-green-dark ring-1 ring-gray-300 focus:ring focus:border-green-700"
                  >
                    Send
                  </button>
                </div>
              </form>
            </Modal>
          </section>
        </section>
      </div>
    </section>
  </div>
</template>

<script>
import { Modal, Rating } from "@/components/t-components";
import { GlobeAlt } from "@/components/icons";
import { required } from "vuelidate/lib/validators";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "TrainerAbout",
  components: {
    GlobeAlt,
    Rating,
    Modal,
  },
  data() {
    return {
      profile: [],
      reviews: [],
      sessions_count: [],
      course_count: [],
      isModalOpen: false,
      message_requests: [],
      banner_url: "",
      LOADING: true,
      showDescritionModal: false,
      reason: "",
      message: "",
    };
  },
  validations: {
    reason: {
      required,
    },
    message: {
      required,
    },
  },
  computed: {
    ...mapGetters(["trainerDetail"]),
  },
  methods: {
    ...mapActions(["getTrainerDetail", "userMessageNew"]),

    messageRequestHandler() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        console.log("invalid");
      } else {
        const data = {
          reason: this.reason,
          message: this.message,
          trainer: this.$route.params.trainer_id,
        };
        this.userMessageNew(data);
        this.isModalOpen = !this.isModalOpen;
        this.message_requests = [];
        this.message_requests.status = 1;
      }
    },

    imgLoadHandler() {
      this.LOADING = false;
    },

    messageTrainerModal() {
      if (this.getToken()) {
        this.isModalOpen = !this.isModalOpen;
      } else {
        this.$router.push({
          name: "Login",
        });
      }
    },
  },
  async created() {
    await this.getTrainerDetail(this.$route.params.trainer_id);
    this.profile = this.trainerDetail.profile;
    this.reviews = this.trainerDetail.reviews;
    this.sessions_count = this.trainerDetail.sessions_count;
    this.course_count = this.trainerDetail.course_count;
    this.message_requests = this.trainerDetail.message_requests;
    this.banner_url =
      this.trainerDetail.profile && this.trainerDetail.profile.banner_url;
    if (this.$route.params.isContactModalOpen) {
      this.isModalOpen = this.$route.params.isContactModalOpen;
    }
  },
};
</script>

<style scoped>
.h-13 {
  height: 13rem;
}
</style>